import { apiHelper } from '@/utils/api.helper'

export const AGENT = {
  getApplicationStatus,
  getStatus,
  getTransactionHistory,
  getAgentTeam,
  applyAsAgent,
  tncAgreement,
  getMemberTransaction,
  getBankList,
  transferToBank,
  convertPoint,
  getUserWithdrawBankList,
  addUserWithdrawalBank,
  deleteUserWithdrawalBank,
  downloadTransactionPDF
}

const URL = {
  AGENT: 'agent',
  GET_APPLICATION: 'getapplication',
  STATUS: 'status',
  TRANSACTION: 'transaction',
  MY_TEAM: 'myteam',
  APPLICATION: 'application',
  MEMBER_TRANSACTION: 'membertransaction',
  BANK_LIST: 'bank_list',
  CASH_OUT: 'cash_out',
  CONVERT_POINT: 'convert_point',
  TNC: 'tnc',
  WITHDRAW_BANK: 'withdrawalsbank'
}

function getApplicationStatus() {
  return apiHelper().get(`${URL.AGENT}/${URL.GET_APPLICATION}`)
}

function getStatus() {
  return apiHelper().get(`${URL.AGENT}/${URL.STATUS}`)
}

function getTransactionHistory(data) {
  return apiHelper().get(`${URL.AGENT}/${URL.TRANSACTION}`, {
    params: data
  })
}

function getAgentTeam(data) {
  return apiHelper().get(`${URL.AGENT}/${URL.MY_TEAM}`, {
    params: data
  })
}

function applyAsAgent(data) {
  return apiHelper().post(`${URL.AGENT}/${URL.APPLICATION}`, null, {
    params: data
  })
}

function tncAgreement(data) {
  return apiHelper().put(`${URL.AGENT}/${URL.TNC}`, null, {
    params: data
  })
}

function getMemberTransaction(data) {
  return apiHelper().get(`${URL.AGENT}/${URL.MEMBER_TRANSACTION}`, {
    params: data
  })
}

function getBankList() {
  return apiHelper().get(`${URL.AGENT}/${URL.BANK_LIST}`)
}

function transferToBank(data) {
  return apiHelper().post(`${URL.AGENT}/${URL.CASH_OUT}`, null, {
    params: data
  })
}

function convertPoint(data) {
  return apiHelper().post(`${URL.AGENT}/${URL.CONVERT_POINT}`, null, {
    params: data
  })
}

function getUserWithdrawBankList() {
  return apiHelper().get(`${URL.AGENT}/${URL.WITHDRAW_BANK}`)
}

function addUserWithdrawalBank(data) {
  return apiHelper().post(`${URL.AGENT}/${URL.WITHDRAW_BANK}`, null, {
    params: data
  })
}

function deleteUserWithdrawalBank(id) {
  return apiHelper().delete(`${URL.AGENT}/${URL.WITHDRAW_BANK}/${id}`)
}

function downloadTransactionPDF(data) {
  return apiHelper().get(`${URL.AGENT}/${URL.TRANSACTION}`, {
    params: data,
    responseType: 'blob'
  })
}
